import clsx from 'clsx';
import { FunctionComponent, useState } from 'react';
import { InviteDate } from '../InviteDate/InviteDate';
import inviteCardBackground from './invite-card-background.png';
import classes from './InviteTicket.module.scss';

interface InviteTicketProps {
    className?: string;
    date?: Date;
    time?: string;
    pattern?: 'golden' | 'confetti';
}

export const InviteTicket: FunctionComponent<InviteTicketProps> = ({ className, date, time, pattern, children }) => {
    const [topCutoutId] = useState(() => 'top-cutout-' + Math.random().toString(36).substring(2, 15));
    const [bottomCutoutId] = useState(() => 'bottom-cutout-' + Math.random().toString(36).substring(2, 15));
    const [cutoutMaskId] = useState(() => 'cutout-mask-' + Math.random().toString(36).substring(2, 15));
    const [goldenGradientId] = useState(() => 'golden-gradient-' + Math.random().toString(36).substring(2, 15));

    return (
        <div
            className={clsx(classes.container, className, {
                [classes.withGolden]: pattern === 'golden',
                [classes.withConfetti]: pattern === 'confetti',
                [classes.withDate]: date && time,
            })}
        >
            <svg xmlns="http://www.w3.org/2000/svg" className={classes.background}>
                <defs>
                    <pattern id={topCutoutId} x="0" y="0" width="18" height="18" patternUnits="userSpaceOnUse">
                        <ellipse ry="6" rx="6" cx="9" fill="#000" />
                    </pattern>

                    <pattern id={bottomCutoutId} x="0" y="100%" width="18" height="18" patternUnits="userSpaceOnUse">
                        <ellipse ry="6" rx="6" cx="9" cy="18" fill="#000" />
                    </pattern>

                    <mask id={cutoutMaskId}>
                        <rect x="0" y="0" width="100%" height="100%" fill="#fff" rx="18" ry="10" />
                        <rect x="0" y="0" width="100%" height="14" fill={`url(#${topCutoutId})`} />
                        <rect x="0" y="calc(100% - 14px)" width="100%" height="18" fill={`url(#${bottomCutoutId})`} />
                    </mask>

                    <linearGradient id={goldenGradientId} x1="29%" y1="5%" x2="71%" y2="95%" gradientUnits="objectBoundingBox">
                        <stop offset="0%" stopColor="#c49a24" />
                        <stop offset="25%" stopColor="#d9b548" />
                        <stop offset="45%" stopColor="#e8cc70" />
                        <stop offset="55%" stopColor="#f2dfa0" />
                        <stop offset="65%" stopColor="#e8cc70" />
                        <stop offset="80%" stopColor="#d9b548" />
                        <stop offset="100%" stopColor="#c49a24" />
                    </linearGradient>
                </defs>

                <rect
                    x="0"
                    y="0"
                    height="100%"
                    width="100%"
                    fill={pattern === 'golden' ? `url(#${goldenGradientId})` : '#fff'}
                    mask={`url(#${cutoutMaskId})`}
                />

                {pattern === 'confetti' && (
                    <image
                        href={inviteCardBackground}
                        height="148"
                        width="100%"
                        mask={`url(#${cutoutMaskId})`}
                        preserveAspectRatio="xMidYMin slice"
                    />
                )}
            </svg>

            <div className={classes.content}>{children}</div>

            {date && time && <InviteDate date={date} time={time} className={classes.date} />}
        </div>
    );
};
